import React from 'react'

const ManagementTasksSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_555_29396)" />
    <path
      d="M40.8046 48.7927C38.1624 48.7927 35.5202 48.7927 32.878 48.7927C31.8871 48.7927 31.0064 48.1322 30.7862 47.2515C30.4559 45.9304 31.4468 44.6643 32.7679 44.6643C35.1348 44.6643 37.5018 44.6643 39.8688 44.6643C42.8413 44.6643 45.8688 44.6643 48.8413 44.6643C49.777 44.6643 50.6578 45.3799 50.8229 46.2606C51.0431 47.1964 50.6027 48.1872 49.722 48.5726C49.3917 48.7377 49.0064 48.7927 48.6761 48.7927C46.144 48.7927 43.4468 48.7927 40.8046 48.7927Z"
      fill="white"
    />
    <path
      d="M40.8596 28.3156C38.2174 28.3156 35.5752 28.3156 32.933 28.3156C31.722 28.3156 30.7862 27.4348 30.7862 26.2238C30.7862 25.0679 31.722 24.1321 32.933 24.1321C38.2174 24.1321 43.5569 24.1321 48.8413 24.1321C49.9972 24.1321 50.8229 24.9027 50.9881 26.0036C51.0982 27.0495 50.4376 27.9853 49.3367 28.2605C49.1716 28.3156 49.0064 28.3156 48.8413 28.3156C46.144 28.3156 43.5018 28.3156 40.8596 28.3156Z"
      fill="white"
    />
    <path
      d="M40.8596 34.1505C43.5569 34.1505 46.1991 34.1505 48.8963 34.1505C49.8871 34.1505 50.7679 34.9211 50.933 35.8569C51.0982 36.9028 50.5477 37.8936 49.5018 38.1689C49.2816 38.2789 49.0615 38.2789 48.8413 38.2789C43.5018 38.2789 38.1624 38.2789 32.8229 38.2789C31.722 38.2789 30.8413 37.4533 30.7312 36.3523C30.6211 35.3065 31.3367 34.3707 32.4376 34.1505C32.6027 34.0955 32.7679 34.0955 32.933 34.0955C35.5752 34.1505 38.2174 34.1505 40.8596 34.1505Z"
      fill="white"
    />
    <path
      d="M22.6945 24.9577C23.4651 24.1871 24.1257 23.4165 24.8413 22.7009C25.1716 22.3706 25.4468 22.0403 25.7771 21.71C26.4376 21.0495 27.3734 21.0495 28.0339 21.655C28.6945 22.2605 28.6945 23.2513 28.089 23.9119C26.8229 25.288 25.5569 26.6091 24.2908 27.9302C23.1899 29.0862 21.5385 28.9211 20.6027 27.5999C20.1624 26.9394 19.722 26.2788 19.2816 25.6183C18.7862 24.7926 18.9514 23.8568 19.722 23.3614C20.4376 22.866 21.4284 23.0862 21.9789 23.8568C22.1991 24.1871 22.4193 24.5724 22.6945 24.9577Z"
      fill="white"
    />
    <path
      d="M22.9147 38.3339C24.0699 38.3339 25.0064 37.3974 25.0064 36.2421C25.0064 35.0869 24.0699 34.1504 22.9147 34.1504C21.7594 34.1504 20.8229 35.0869 20.8229 36.2421C20.8229 37.3974 21.7594 38.3339 22.9147 38.3339Z"
      fill="white"
    />
    <path
      d="M22.9147 48.7926C24.0699 48.7926 25.0064 47.8561 25.0064 46.7009C25.0064 45.5456 24.0699 44.6091 22.9147 44.6091C21.7594 44.6091 20.8229 45.5456 20.8229 46.7009C20.8229 47.8561 21.7594 48.7926 22.9147 48.7926Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_555_29396"
        x1="34.5455"
        y1="2.70945e-07"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EA1225" />
        <stop offset="1" stopColor="#BA0B1B" />
      </linearGradient>
    </defs>
  </svg>
)

export default ManagementTasksSubcategory
